import axios from "axios";
import { baseAPI } from "../../utils/constants";
import { setKey } from "../../utils/localStorage";

export enum LOGIN_ACTIONS {
  LOGIN_FAILED = "LOGIN_FAILED",
  LOGIN_PENDING = "LOGIN_PENDING",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
}

export const loginFailed = (payload) => ({
  type: LOGIN_ACTIONS.LOGIN_FAILED,
  payload,
});

export const loginPending = () => ({
  type: LOGIN_ACTIONS.LOGIN_PENDING,
});

export const loginSuccess = (payload) => ({
  type: LOGIN_ACTIONS.LOGIN_SUCCESS,
  payload,
});

export const login = (userName: string, password: string) => async (dispatch) => {
    dispatch(loginPending());
    try {
      const response = await axios.post(`${baseAPI}/login`, {
        username: userName,
        password,
      });
      const {
          data : {
            token = "",
          },
      } = response;
      setKey("token", token);
      const { uid, typ } = JSON.parse(atob(token.split(".")[1]));
      dispatch(loginSuccess({ userId: uid, userType: typ }));
      return typ;
    } catch (error) {
      dispatch(loginFailed("unable to login"));
    }
};
